import {makeStyles, withStyles} from "@material-ui/styles";
import React from "react";
import {TextField} from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    menuPaper: {
        maxHeight: 350
    }
}));


export const TextFieldCustom = withStyles({
    root: {
        "& .MuiInputBase-root.Mui-disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.07)"
        }
    }
})(TextField);